import React, { createContext } from "react";
export const ObservationFormContext = createContext(null);
